var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-form-item',{attrs:{"label":"地址"}},[_c('avue-input',{model:{value:(_vm.main.activeObj.data.value),callback:function ($$v) {_vm.$set(_vm.main.activeObj.data, "value", $$v)},expression:"main.activeObj.data.value"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }